import React from 'react';
import { motion } from 'framer-motion';
import CardComponent from './Cards';

export default function AnimatedFaceDownHand({ count, vertical, playerIndex, myId }) {
  const cards = Array.from({ length: count || 0 });

  return (
    <div className={vertical ? "hand-facedown-v" : "hand-facedown"}>
      {cards.map((_, i) => {
        const layoutId = `opp-${playerIndex}-card-${i}`;
        
        return (
          <motion.div
            key={layoutId}
            layoutId={layoutId}
            className="facedown-card-wrapper"
            initial={{ opacity: 0, scale: 0, x: 0, y: 0 }}
            animate={{ 
              opacity: 1, 
              scale: 1,
              /* THE FIX: Apply rotation to the wrapper so the layout engine respects it */
              rotate: vertical ? 90 : 0 
            }}
            transition={{
              type: "spring",
              stiffness: 260,
              damping: 25,
              delay: (playerIndex * 0.12) + (i * 0.06) 
            }}
          >
            <CardComponent faceDown={true} />
          </motion.div>
        );
      })}
    </div>
  );
}